import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { catchError, debounce } from 'rxjs/operators';
import 'rxjs/add/observable/of';

import { FilterBoxService } from '../services/filter-box.service';

export class GenericDataSource implements DataSource<any> {
    private resultsSubject = new BehaviorSubject<any[]>(null);
    private loadingSubject = new BehaviorSubject<boolean>(true);

    public loading$ = this.loadingSubject.asObservable();

    constructor(private filterBoxService: FilterBoxService) {
    }

    connect(collectionViewer: CollectionViewer): Observable<any[]> {
        return this.resultsSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.resultsSubject.complete();
        this.loadingSubject.complete();
    }

    loadResults(dataArraySource, filterMap) {
	this.loadingSubject.next(true);

	//console.log("generic-data-source loadResults", dataArraySource, filterMap);
	this.filterBoxService.filter(dataArraySource, filterMap)
	.pipe(
	    debounce(() => Observable.interval(750)),
	    catchError(() => Observable.of(null)),
	).subscribe(result => {
	    if(result && filterMap){
		//console.log("loadResults", result, dataArraySource, filterMap);
		this.loadingSubject.next(false);
		this.resultsSubject.next(result);
	    }
	});
    }
}
